module.exports = __webpack_public_path__ + "static/media/submitimg.240e71dd.webp";